import DOMPurify from "dompurify";
import { cdnImage, cdnSrcSet } from "./cdnImage";

// Sanitizer for CMS / API HTML rendered with dangerouslySetInnerHTML.
// HTML + SVG profiles so inline SVG icons keep rendering; iframes are kept
// for CMS video embeds (DOMPurify still blocks javascript:/data: URLs).
const CONFIG = {
  USE_PROFILES: { html: true, svg: true, svgFilters: true },
  ADD_TAGS: ["iframe"],
  ADD_ATTR: [
    "target",
    "allow",
    "allowfullscreen",
    "frameborder",
    "loading",
    "decoding",
    "fetchpriority",
  ],
};

// CMS images (absolute www URLs in the back-office HTML) through the image CDN, like product images.
// cdnImage/cdnSrcSet return nothing new when the CDN is off (REACT_APP_IMAGE_BASE empty) or the URL is
// not one of our image paths, so the HTML stays exactly as it was then.
const CMS_IMAGE_WIDTHS = [400, 800, 1200, 1600];
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName !== "IMG") return;
  const src = node.getAttribute("src");
  if (!src) return;
  const cdnSrc = cdnImage(src, { width: 1600 });
  if (cdnSrc === src) return;
  node.setAttribute("src", cdnSrc);
  if (!node.getAttribute("srcset")) {
    const srcSet = cdnSrcSet(src, CMS_IMAGE_WIDTHS);
    if (srcSet) {
      node.setAttribute("srcset", srcSet);
      if (!node.getAttribute("sizes")) node.setAttribute("sizes", "(max-width: 768px) 100vw, 50vw");
    }
  }
});

export const sanitizeHtml = (html) => {
  if (html === null || html === undefined || html === "") return "";
  return DOMPurify.sanitize(String(html), CONFIG);
};

export default sanitizeHtml;
